import React, { useRef } from "react";
import { Card } from "primereact/card";
import { Chart } from "primereact/chart";
import { useSelector } from "react-redux";
import copy from "copy-to-clipboard";
import { Toast } from "primereact/toast";

const ClipboardIcon = () => (
  <svg
    width="1.5rem"
    height="1.5rem"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 5.00005C7.01165 5.00082 6.49359 5.01338 6.09202 5.21799C5.71569 5.40973 5.40973 5.71569 5.21799 6.09202C5 6.51984 5 7.07989 5 8.2V17.8C5 18.9201 5 19.4802 5.21799 19.908C5.40973 20.2843 5.71569 20.5903 6.09202 20.782C6.51984 21 7.07989 21 8.2 21H15.8C16.9201 21 17.4802 21 17.908 20.782C18.2843 20.5903 18.5903 20.2843 18.782 19.908C19 19.4802 19 18.9201 19 17.8V8.2C19 7.07989 19 6.51984 18.782 6.09202C18.5903 5.71569 18.2843 5.40973 17.908 5.21799C17.5064 5.01338 16.9884 5.00082 16 5.00005M8 5.00005V7H16V5.00005M8 5.00005V4.70711C8 4.25435 8.17986 3.82014 8.5 3.5C8.82014 3.17986 9.25435 3 9.70711 3H14.2929C14.7456 3 15.1799 3.17986 15.5 3.5C15.8201 3.82014 16 4.25435 16 4.70711V5.00005M12 11H9M15 15H9"
      stroke="#000000"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const Home = ({ userData, calcluatedEarning, baseAmount, calculatedPaid }) => {
  const toastRef = useRef(null);

  const currencySymbol = useSelector((state) => state.currencySymbol.symbol);
  const currencyFactor = useSelector((state) => state.currencySymbol.factor);

  const handleCopy = () => {
    copy(userData.partner_code);
    toastRef.current.show({
      severity: "success",
      summary: "Copied",
      detail: "Partner code copied to clipboard",
    });
  };

  const earningsData = {
    labels: userData?.salesData?.map((item) => item.month),
    datasets: [
      {
        label: "Number of Sales",
        backgroundColor: "#42A5F5",
        data: userData?.salesData?.map((item) => item.count),
      },
    ],
  };

  return (
    <>
      <Toast ref={toastRef} />
      <div className="col-md-6 mb-3">
        <Card title="User Information" style={{ width: "100%" }}>
          <p className="d-flex align-items-center">
            <span>
              <strong>Partner Code: </strong> {userData.partner_code}{" "}
            </span>
            <button
              className="btn btn-link p-0 ml-2"
              onClick={handleCopy}
              aria-label="Copy to clipboard"
            >
              <ClipboardIcon />
            </button>
          </p>
          <p>
            <strong>Email:</strong> {userData.email}
          </p>
          <p>
            <strong>Earnings:</strong> {currencySymbol}
            {(calcluatedEarning * currencyFactor).toFixed(2)}
          </p>
          <p>
            <strong>Paid:</strong> {currencySymbol}
            {((calculatedPaid || 0) * currencyFactor).toFixed(2)}
          </p>
        </Card>
      </div>
      <div className="col-md-6 mb-3">
        <Card title="Earnings Chart" style={{ width: "100%" }}>
          <Chart type="bar" data={earningsData} />
        </Card>
      </div>
    </>
  );
};

export default Home;
